<template>
  <div>
    <CCard>
      <CCardBody>
        <CRow>
          <CCol col="6">
            <CSelect
              :value.sync="mesSelecionado"
              :options="mes"
              required
              prepend="MÊS"
              placeholder=" "
              @change="listarPPM"
            >
              <template #append-content>
                <CIcon name="cil-badge" />
              </template>
            </CSelect>
          </CCol>
          <CCol col="6">
            <CSelect
              :value.sync="anoSelecionado"
              :options="anos"
              required
              prepend="ANO"
              @change="listarPPM"
            >
              <template #append-content>
                <CIcon name="cil-badge" />
              </template>
            </CSelect>
          </CCol>
        </CRow>
        <CDataTable
          :items="items"
          :fields="fields"
          :noItemsView="not_found"
          column-filter
          hover
          sorter
          small
          :fixed="fixed"
          :items-per-page="15"
          :dark="dark"
          pagination
        >
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { cilArrowBottom } from "@coreui/icons";
import moment from "moment";
export default {
  data() {
    return {
      items: [],
      metaConvenio: false,
      metaParticular: false,
      fields: [
        {
          key: "name",
          label: "Profissional",
          _style: "min-width:200px",
        },
        {
          key: "total_consultas",
          label: "Total de Consultas",
          _style: "min-width:100px;",
          filter: false,
        },
        {
          key: "total_convenio",
          label: "Total de Consultas Convênio",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "total_particular",
          label: "Total de Consultas Particulares",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "valor_convenio",
          label: "Total R$ Convênio",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "pprconvenio",
          label: "PPR R$ Convênio",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "valor_particular",
          label: "Total R$ Particular",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "pprparticular",
          label: "PPR R$ Particular",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "total_geral",
          label: "Total Geral R$",
          sorter: false,
          filter: false,
        },
      ],
      // Mês e ano values
      mesSelecionado: null,
      anoSelecionado: null,

      // Filtro mês e ano
      mes: [
        { label: "JANEIRO", value: "1" },
        { label: "FEVEREIRO", value: "2" },
        { label: "MARÇO", value: "3" },
        { label: "ABRIL", value: "4" },
        { label: "MAIO", value: "5" },
        { label: "JUNHO", value: "6" },
        { label: "JULHO", value: "7" },
        { label: "AGOSTO", value: "8" },
        { label: "SETEMBRO", value: "9" },
        { label: "OUTUBRO", value: "10" },
        { label: "NOVEMBRO", value: "11" },
        { label: "DEZEMBRO", value: "12" },
      ],
      anos: [],

      not_found: {
        noResults: "Nenhum registro encontrado",
        noItems: "Nenhum registro encontrado",
      },
      // Valor geral
      valor_geral: "",
      meses: [{}],

      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
    };
  },
  methods: {
    async listarPPM() {
      await this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}lista-ppm`, {
          ano: this.anoSelecionado,
          mes: this.mesSelecionado,
        })
        .then((res) => res.json())
        .then((res) => {
          this.items = [];
          res.forEach((item) => {
            item.pprconvenio = item.pprconvenio.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
            item.pprparticular = item.pprparticular.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
            item.total_geral = item.total_geral.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
            item.valor_convenio = item.valor_convenio.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
            item.valor_particular = item.valor_particular.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });


            for (const [key, value] of Object.entries(item)) {
              if (typeof value === "number") {
                item[key] = value.toFixed(2);
              }
            }
            this.items.push(item);
          });

          console.log({ items: this.items });
        });
    },
    carregarAnosRegistrados() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-anos-registrados`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            this.anos.push(elem.ano);
          });

          this.anoSelecionado = this.anos[this.anos.length - 1];
        });
    },
  },
  mounted() {
    this.listarPPM();
    this.carregarAnosRegistrados();
  },
};
</script>
<style scoped></style>
